if (document.querySelector('[showelementsfromgroup]')) {
    let showElementsFromGroup = Array.from(document.querySelectorAll('[showelementsfromgroup]'));
    let nameForm = document.querySelector('[showelementsfromgroup]').closest('form').name;
    const listGroup = {};

    showElementsFromGroup.forEach(element => {
        let listShowElementsFromGroup = element.getAttribute('showelementsfromgroup');
        let listInput = element.querySelectorAll('input');
        let nameGroup = listShowElementsFromGroup.substring(0, (listShowElementsFromGroup.indexOf("("))).trim();
        let listAllValues = listShowElementsFromGroup.substring((listShowElementsFromGroup.indexOf("(")) + 1, (listShowElementsFromGroup.indexOf(")"))).split(';');

        //We check if the group already exists in listGroup
        let tabKeyValue = listGroup[nameGroup] || {};
        listAllValues.forEach((values) => {
            let valueforCheck = values.substring(0, (values.indexOf("["))).trim();
            tabKeyValue[valueforCheck] = values.substring((values.indexOf("[")) + 1, (values.indexOf("]"))).split(';');
        });

        // Check if "inputs" key already exists for the group, then merge the lists.
        if (tabKeyValue.hasOwnProperty('inputs')) {
            tabKeyValue['inputs'] = [...tabKeyValue['inputs'], ...listInput];
        } else {
            tabKeyValue['inputs'] = listInput;
        }

        listGroup[nameGroup] = tabKeyValue;
        hideElements(listGroup[nameGroup]);
    });

    Object.entries(listGroup).forEach(([groupName, tabKeyValue]) => {
        tabKeyValue.inputs.forEach(input => {
            input.addEventListener('change', (e) => {

                let getAttributeShow = input.closest('[showelementsfromgroup]').getAttribute('showelementsfromgroup')
                let inputNameGroup = getAttributeShow.substring(0, (getAttributeShow.indexOf("("))).trim();
                hideElements(listGroup[inputNameGroup]);

                if (input.checked) {
                    if (tabKeyValue[input.value]) {
                        tabKeyValue[input.value].forEach(value => {
                            if (value.nodeName !== 'INPUT') {
                                let listValue = value.split(',');
                                listValue.forEach(val => {
                                    if (document.querySelector(`[data-field-name="${val}"]`)) {
                                        document.querySelector(`[data-field-name="${val}"]`).classList.remove('d-none');
                                        window.scrollBy(0, 350);
                                    } else if (document.querySelector(`[name="${nameForm}[${val}]"]`)) {
                                        document.querySelector(`[name="${nameForm}[${val}]"]`).closest('.form-group').classList.remove('d-none');
                                        window.scrollBy(0, 350);
                                    }
                                });
                            }
                        });
                    }
                }


            });
        })

    });

    function hideElements(listGroup) {
        Object.entries(listGroup).forEach(([key, value]) => {
            value.forEach(el => {
                if (el.nodeName !== 'INPUT') {
                    let listValue = el.split(',');
                    listValue.forEach(val => {
                        if (document.querySelector(`[data-field-name="${val}"]`)) {
                            document.querySelector(`[data-field-name="${val}"]`).classList.add('d-none');
                        } else if (document.querySelector(`[name="${nameForm}[${val}]"]`)) {
                            document.querySelector(`[name="${nameForm}[${val}]"]`).closest('.form-group').classList.add('d-none');
                        }
                    });
                }
            });
        });
    }
}




